import React from 'react'
import { ThemeProvider } from '@mui/material'
import Box from '@mui/material/Box'
import { theme } from '../../../theme/DashboardTheme'
import { ScanWidget } from '../../Views/HomeViews/ScanWidget'

interface HeaderCardProps {
  count:string
}

const ScannedSites: React.FC<HeaderCardProps> = ({ }) => {
  return (
    <ThemeProvider theme={theme}>
    <Box display="flex" alignItems="center" bgcolor={'#fff'}   boxShadow={'0px 12.67px 22.52px 0px #D0D2DA5E'} borderRadius={3} >
      <Box sx={{display: 'flex', width: '100%'}}>
        <ScanWidget />
      </Box>
    </Box></ThemeProvider>
  )
}

export default ScannedSites